import React, { FC, useMemo } from "react";
import ReactSelect from "react-select";

import { useThemeContext } from "~/context/ThemeContext/ThemeContext";
import { grey } from "~/ui-kit/colors/colors";

import { SelectOption } from "./Select.types";
import { getCustomStyles } from "./Select.util";

export type SelectProps = {
  options: SelectOption[];
  onChange: (value: string) => void;
  value: string;
  defaultOption?: SelectOption;
  isSearchable?: boolean;
  placeholder?: string;
};

export const Select: FC<SelectProps> = ({
  options = [],
  onChange,
  defaultOption = null,
  value,
  isSearchable = false,
  placeholder = "",
  ...props
}) => {
  const selectedOption = useMemo(
    () => options.find((option) => option.value === value) ?? null,
    [value, options]
  );
  const { primaryColor } = useThemeContext();
  return (
    <ReactSelect
      {...props}
      defaultValue={defaultOption}
      options={options}
      onChange={({ value }) => {
        onChange(value);
      }}
      isSearchable={isSearchable}
      value={selectedOption}
      styles={getCustomStyles({ primaryColor })}
      // TODO: Consider setting lighter versions of primaryColor25
      // Instead of using grey
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: grey[200],
          primary50: primaryColor,
          primary: primaryColor,
        },
      })}
      placeholder={placeholder}
    />
  );
};
